var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonPraying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M380.2 165.6c-5.781-6.719-15.87-7.453-22.56-1.75l-84.59 72.52c-3.5 2.984-7.906 4.297-12.56 3.688c-4.625-.625-8.562-3.109-11.16-6.969l-27-40.52C207.9 170.1 184 159 157.9 160.6C131.1 162.3 109.6 177.1 97.97 200.3L58.16 279.9c-17.72 35.44-7.188 77.86 25.03 100.9L222.1 480H16C7.156 480 0 487.2 0 496S7.156 512 16 512h255.1c6.969 0 13.12-4.5 15.25-11.11c2.094-6.625-.2813-13.88-5.938-17.91l-179.5-128.2C82.47 340.1 76.15 315.5 86.78 294.2L126.6 214.6c6.438-12.89 18.88-21.12 33.28-22.03c13.84-.9531 27.75 5.719 35.78 17.73l26.1 40.52c7.625 11.44 19.81 19.06 33.41 20.92c13.81 2.047 27.41-2.188 37.75-11.09l84.59-72.5C385.1 182.4 385.9 172.3 380.2 165.6zM255.1 128c35.35 0 63.1-28.65 63.1-64s-28.65-64-63.1-64S191.1 28.65 191.1 64S220.6 128 255.1 128zM255.1 32c17.64 0 32 14.36 32 32s-14.36 32-32 32s-32-14.36-32-32S238.4 32 255.1 32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonPraying);
export default __webpack_public_path__ + "static/media/person-praying.2a76a2a1a8ca7df6a15b918c9627ea8b.svg";
export { ForwardRef as ReactComponent };